import { useContext, createContext, useState, useEffect, useRef } from "react";
import { AppContext } from "../App";
import CheckersCell from "../components/CheckersCell";
import SpanishCheckers from "../models/SpanishCheckers";
import { callApi, WEB_SOCKET_URL } from "../CoreHelper";
import CheckersPlayerTile from '../ones/CheckerPlayerTile';
import { MdOutlineChat, MdKeyboardArrowLeft, MdOutlineRefresh } from 'react-icons/md';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { AppContext as MainAppContext } from "../../App";
import logo_wide from '../assets/logo_wide.png';
import { 
  BsFillChatDotsFill,
} from 'react-icons/bs';
import { FaHandsWash } from 'react-icons/fa';
import MobileInterface from "../../MobileInterface";


export const GameContext = createContext(null);
export default function SpanishCheckersBoard(props) {

  const app = useContext(AppContext);
  const mainApp = useContext(MainAppContext);

  const [ board, setBoard ] = useState(getBoardState(app.gameData)); //this sets the board state 
  const [ selectedPiece, setSelectedPiece ] = useState(null); // row, col
  const [ selectedDestinationCell, setSelectedDestinationCell ] = useState(null);
  const [ nextPossiblePositions, setNextPossiblePositions ] = useState(null);
  const [ boardLocked, setBoardLocked ] = useState(false);
  const [ error, setError ] = useState(null);
  const [ message, setMessage ] = useState(null);
  const webSocketRef = useRef(null);

  function getBoardState(_gameData) {
    return JSON.parse(_gameData.boardData).board;
  }
  
  function resetSelections(fromSubmitMove = false) {
    setNextPossiblePositions(null);
    setSelectedDestinationCell(null);
    setSelectedPiece(null);
    
    if(!fromSubmitMove) {
      setBoard(getBoardState(app.gameData));
    }
  }

  async function submitMove(_selectedPiece, _selectedDestinationCell) {
    //this submits move to be validated at the game server
    if(_selectedPiece && _selectedDestinationCell) {
      setBoardLocked(true);
      setMessage('Syncing, please wait...')
      await callApi("submit-move", {
        userId: app.userId,
        userToken: app.userToken,
        gameId: app.gameId,
        gameType: app.gameType,
        playMode: app.playMode,
        selectedDestinationCell: JSON.stringify(_selectedDestinationCell),
        selectedPiece: JSON.stringify(_selectedPiece),
      }).then(response => {
        if(response.status === 1) {
          //refresh gamedata
          app.getGameData();
          resetSelections(true);
          setMessage(false);
          setError(false);
        } else {
          setError(response.msg);
          resetSelections();
        }
      })
      setBoardLocked(false);
    } else {
      //invalid move
      setError("invalid move");
      resetSelections();
    }
  }

  function isCurrentPlayer() {
    return (app.gameData && app.gameData.currentPlayer === Number(app.userId) && app.gameData.status === 'ongoing')
  }

  function canPieceMove(piece) {
    //this checks if the piece can move on the current board (and board state)
    setError(false);
    setMessage(false);
    const allowedPositions = SpanishCheckers.getNextPiecePositions({ piece, board });
    console.log("Allowed Position for selected piece", allowedPositions);

    if(allowedPositions && allowedPositions.length === 0) {
      setError("Selected piece cannot move as per game rules")
    }

    setNextPossiblePositions(allowedPositions);
    if(allowedPositions.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  const gameContext = {
    board, 
    setBoard,
    selectedPiece,
    setSelectedPiece,
    selectedDestinationCell,
    setSelectedDestinationCell,
    canPieceMove,
    setNextPossiblePositions,
    nextPossiblePositions,
    submitMove,
    boardLocked,
    setBoardLocked,
    message,
    error,
    setError,
    setMessage,
    resetSelections,
  }

  useEffect(() => {

  }, [ ])

  useEffect(() => {
    if(app.gameData) {
      setBoard(getBoardState(app.gameData));

      if(isCurrentPlayer()) {
        //haptic
        MobileInterface.playSound('vibrate');
      }

      if(app.gameData && app.gameData.drawStatus === 'pending' && Number(app.gameData.drawerId) !== Number(app.userId)) {
        //haptic
        MobileInterface.playSound('vibrate');
      }
    }
  }, [ app.gameData ])

  useEffect(() => {
    if(board) {
      //handle game state changes
    }
  }, [ board ])

  useEffect(() => {
    console.log(error);
  }, [ error ])

  return (
    <GameContext.Provider value={gameContext}>
      <div 
        className="CoreCheckersPlayersBanner coreShadow"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12 d-flex justify-content-between">
              <img 
                src={logo_wide} 
                className="align-self-center"
                style={{ 
                  height:"50px", 
                  marginLeft: "0px",
                  marginRight: "10px",
                  marginTop: "10px",
                  marginBottom: "10px", 
                  width: "auto",
                  flexShrink: "0",
                }}
              />

              <div className="d-flex align-self-center justify-content-end">
                <MdOutlineRefresh 
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    cursor: "pointer"
                  }} 
                  onClick={app.refresh}
                  className="mNoPadding align-self-center" 
                  size={30}
                />

                <button
                  onClick={app.navBack}
                  className="btn btn-sm core-bg-redish align-self-center d-flex"
                  style={{
                    flexShrink: "0",
                    margin: "0",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    paddingTop: "5px",
                    paddingBottom: "5px",
                    width: "auto"
                  }}
                >
                  <MdKeyboardArrowLeft className="mNoMargin mNoPadding align-self-center" size={30}/>
                </button>
              </div>
            </div>

            <div className="col-6">
              <CheckersPlayerTile type="player"/>
            </div>

            <div className="col-6">
              <CheckersPlayerTile type="opponent"/>
            </div>

            <div className="col-6" style={{ marginTop: "10px" }}>
              <div className="" style={{ maxWidth: "200px", margin: "0 auto" }}>
                <h5 className="font-bold core-text-goldish">Spanish Checkers</h5>
              </div>
            </div>

            <div className="col-6" style={{ marginTop: "10px" }}>
              <div className="text-end" style={{ maxWidth: "200px", margin: "0 auto" }}>
                <h6 style={{ fontSize: "12px" }} className="text-muted">No capture: {app.gameData.noCaptureMoves}</h6>
                <h6 style={{ fontSize: "12px" }} className="text-muted">Draws: {app.gameData.drawsNumber}</h6>
              </div>
            </div>

          </div>
        </div>
      </div>


      <div 
        className="CoreCheckersBoard"
        data-is-opponent={(app.gameData && Number(app.gameData.opponentId) === Number(app.userId))}
      >
        {
          (board) ?
          board.map((row, rowIndex) => {
            return row.map((col, colIndex) => {
              //console.log(board[rowIndex][colIndex]);
              return (
                <CheckersCell
                  key={rowIndex+"-"+colIndex}
                  row={rowIndex}
                  col={colIndex}
                  value={board[rowIndex][colIndex]}
                  nextPossiblePositions={nextPossiblePositions}
                />
              )
            })
          }): ""
        }
      </div>

      {
        (app.mode === 'play' && app.gameData.status === 'ongoing') ?
        <div 
          className="CoreCheckersInfoBanner"
        >
          <div className="container ">
            {
              (app.webSocketConnected === 0) ?
              <h6
                className="font-regular core-text-redish"
                style={{
                  fontSize: "12px",
                }}
              >
                Lost connection, reconnecting... <br/>Refresh if it takes long
              </h6>:""
            }

            {
              (isCurrentPlayer()) ?
              <div className="text-center" style={{ width: "100%", marginBottom: "5px" }}>
                <h6
                  style={{
                    width: "200px",
                    margin: "0 auto",
                    padding: "5px",
                    fontSize: "14px",
                  }}
                  className="core-bg-maronish font-semi-bold"
                >
                  YOUR TURN TO PLAY
                </h6>
              </div>:""
            }

            {
              (error || message) ?
              <div
                className="font-light coreShadow"
                style={{
                  height: "50px",
                  width: "100%",
                  padding: "5px",
                  fontSize: "12px",
                  background: "var(--core-faintBlack)",
                  overflow: "hidden",
                  marginTop: "10px",
                }}
              >
                <div className="row">
                  <div className="col-10">
                    {error || message}
                  </div>

                  <div className="col-2 text-end">
                    <AiOutlineCloseCircle
                      size={30}
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setError(false);
                        setMessage(false);
                      }}
                    />
                  </div>
                </div>
              </div>: ""
            }

            <div
              className="text-center"
              style={{
                width: "100%",
                padding: "10px",
                overflow: "hidden",
                borderTop: "2px solid var(--core-goldish)",
              }}
            >

              <button onClick={app.triggerChat} className="btn coreCheckersActionBtn">
                <BsFillChatDotsFill
                  className="mIcon"
                /><br/>
                Chat
              </button>

              {
                (app.gameData && !app.gameData.drawStatus) ?
                <button
                  className="btn coreCheckersActionBtn"
                  onClick={() => {
                    mainApp.activateDialog({
                      message: "Are you sure you want to SEND Draw signal",
                      onConfirm: app.sendDrawSignal,
                    })
                  }}
                >
                  Signal Draw
                </button>: ""
              }

              {
                (app.gameData && app.gameData.drawStatus === 'pending' && Number(app.gameData.drawerId) !== Number(app.userId)) ?
                <button
                  className="btn coreCheckersActionBtn"
                  onClick={() => {
                    mainApp.activateDialog({
                      message: "Are you sure you want to ACCEPT Draw signal sent by your opponent?",
                      onConfirm: app.acceptDrawSignal,
                    })
                  }}
                >
                  Accept<br/>Draw
                </button>: ""
              }

              {
                (app.gameData && app.gameData.drawStatus === 'pending' && Number(app.gameData.drawerId) !== Number(app.userId)) ?
                <button
                  className="btn coreCheckersActionBtn"
                  onClick={() => {
                    mainApp.activateDialog({
                      message: "Are you sure you want to IGNORE Draw signal sent by your opponent?",
                      onConfirm: app.ignoreDrawSignal,
                    })
                  }}
                >
                  Ignore<br/>Draw
                </button>: ""
              }

              <button 
                onClick={() => {
                  mainApp.activateDialog({
                    message: "Are you sure you want to give up this game and lose?",
                    onConfirm: app.surrenderGame,
                  })
                }}
                className="btn coreCheckersActionBtn"
              >
                <FaHandsWash
                  className="mIcon"
                /><br/>
                Give Up
              </button>

              

            </div>

          </div>
        </div>
        :""
      }
    </GameContext.Provider>
  )
}